import { mypage_api_config, queryParam } from "utils/APIConfig";
import { ACTION_GET, ACTION_POST } from "utils/AxiosActions";

// ポイント関連はログイン中ユーザー本人のデータのみを扱う（対象ユーザーはサーバー側でトークンから決まる）。
// ブラウザからのポイント付与（旧 Add_Point / Sub_Point）は画面から使われておらず、
// 資格情報なしでは安全に提供できないため削除した。

export const Points_History = async ({ page = 1, size = 5 } = {}) => {
  const _conf = await mypage_api_config();
  const url = `${_conf.endpoints.history_url}?${queryParam({ page, size })}`;
  return ACTION_GET(url, _conf.config);
};

export const Get_Balance = async () => {
  const _conf = await mypage_api_config();
  return ACTION_GET(_conf.endpoints.balance_url, _conf.config);
};

export const Use_Points = async ({ subPoint }) => {
  const _conf = await mypage_api_config();
  return ACTION_POST(_conf.endpoints.redeem_url, { subPoint }, _conf.config);
};
